
<template>
  <v-app-bar
    app
    tile
    clipped-right
    height="64"
    style="z-index: 99;"
  >
    <router-link exact class="d-flex" :to="{ name: 'Home' }">
      <img
        class="logo"
        src="/assets/logo.svg"
        width="300"
        height="45"
        alt=""
      />
    </router-link>
    <v-spacer></v-spacer>
    <v-toolbar-items>

      <!-- <div class="d-none d-sm-flex">
        <SearchBox
          v-if="currentRoute && currentRoute !== 'Home'"
        />
      </div> -->
      <!-- <v-spacer></v-spacer> -->

      <v-btn
        text
        exact
        @click.stop="$emit('openDrawer')"
      >
        <v-icon>mdi-apps</v-icon>
      </v-btn>

      <v-btn
        text
        exact
        v-if="user && user.uid === 0"
        class="btn-login"
        @click="$emit('openDialogLogin')"
      >
        <span>{{ $t('user.login') }}</span>
      </v-btn>

      <v-menu
        bottom
        offset-y
        origin="top right"
        min-width="300px"
        max-width="300px"
        :close-on-content-click="false"
        transition="scale-transition"
        v-if="user && user.uid !== 0"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            text
            exact
            v-if="user"
            v-bind="attrs"
            v-on="on"
            class="btn-login"
          >
            <v-avatar color="primary" size="32">
              <small class="white--text">{{ user.initial }}</small>
            </v-avatar>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar color="primary">
                <small class="white--text">{{ user.initial }}</small>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ user.fullname }}</v-list-item-title>
                <v-list-item-subtitle>{{ user.company }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-tooltip v-model="show" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon :color="userStatusIcon">mdi-airballoon</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ userStatusText }}</span>
                </v-tooltip>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <div v-if="dataUser && Object.keys(dataUser) !== 0">
            <v-list-item
              two-line
              v-for="(u, index) in Object.keys(dataUser)"
              :key="index"
            >
              <v-list-item-content class="py-0">
                <v-list-item-title>{{ $t('user.' + u) }}</v-list-item-title>
                <v-list-item-subtitle v-if="u === 'roles'">
                  <span v-html="user[u].join('<br/>')" />
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="u === 'language'">
                  <img
                    alt=""
                    width="24" height="24"
                    :src="`https://flagsapi.com/${ user[u].toUpperCase() }/flat/24.png`"
                  />
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="!['roles', 'language', 'status'].includes(u)">
                  {{ user[u] }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click.prevent="$emit('onClickLogout')"
            >
              {{ $t('account.logout') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
<!-- 
      <v-menu
        bottom
        left
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            text
            exact
            v-bind="attrs"
            v-on="on"
          >
            <flag :iso="dataFormat" :squared="false" />
          </v-btn>
        </template>

        <v-list :tile="false">
          <v-list-item
            @click="onChangeLanguage(lang.key)"
            v-for="lang in langs"
            :key="lang.key"
          >
            <v-list-item-title class="d-flex align-center">
              <flag :iso="lang.flag" :squared="false" /> <span class="ml-2">{{ lang.label }}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items> -->
    
    <!-- Mobile menu -->
    <!-- <v-menu class="hidden-md-and-up">
      <template v-slot:activator="{ on }">
        <v-app-bar-nav-icon class="hidden-md-and-up" v-on="on"></v-app-bar-nav-icon>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in navigation"
          :key="index"
          :to="{ name: item.link }"
          exact
        >
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          @click="onChangeLanguage(lang.key)"
          v-for="lang in langs"
          :key="lang.key"
        >
          <v-list-item-title class="d-flex align-center">
            <flag :iso="lang.flag" :squared="false" /> <span class="ml-2">{{ lang.label }}</span>
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-btn
          text
          exact
          v-if="user && user.uid === 0"
          class="btn-login"
          @click="$emit('openDialogLogin')"
        >
          <span class="mr-2">{{ $t('user.login') }}</span>
        </v-btn>
        
      </v-list>
    </v-menu> -->
  </v-app-bar>
</template>
<script>
import Mixins from '@/core/mixins'
// import SearchBox from '@/components/layout/SearchBox'
export default {
  name: "Banner",
  mixins: [ Mixins ],
  data () {
    return {
      show: false
    }
  },

  // components: { SearchBox },
  computed: {

    listMarkets () {
      const markets = this.$store.getters["home/termsType"]('markets')
      return markets
    },

    navigation () {
      return [
        // {
        //   link: 'Home',
        //   text: this.$t('menu.home.text'),
        //   title: this.$t('menu.home.title'),
        //   active: false
        // },,
        {
          link: 'MediaLibrary',
          text: this.$t('menu.mediaLibrary.text'),
          title: this.$t('menu.mediaLibrary.title'),
          active: false
        },
        {
          link: 'Groups',
          text: this.$t('menu.markets.text'),
          title: this.$t('menu.markets.title'),
          active: false
        }
      ]
    },

    dataUser () {
      if (this.user) {
        let cloneUser = {}
        for (const u in this.user) {
          if (!['uid', 'initial', 'fullname', 'company', 'status'].includes(u)) {
            cloneUser[u] = this.user[u]
          }
        }
        return cloneUser
      } else {
        return null
      }
    },

    userStatusIcon () {
      return this.user.status === "1" ? 'green' : 'red'
    },

    userStatusText () {
      return this.user.status === "1" ? this.$t('user.active') : this.$t('user.inactive')
    },
  },
  props: {
    currentRoute: String,
    user: Object
  }
}
</script>
<style>
.logo {
  /* width: 100%; */
  height: auto;
  max-width: 100%;
}
.theme--light.v-divider {
  border-color: rgba(0,0,0,.12);
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
  background: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
}
header .v-toolbar__items .v-btn {
  font-weight: normal;
}
header.v-sheet .v-btn {
  color: #085FA9 !important;
}
.btn-login .mr-2 {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
